import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";

import {appSetToggle, setConfirm} from "../../store/actions/appAction";
import {resetFormState} from "../../store/actions/formAction";
import {apiDeleteUser, apiGetUsers} from "../../api/userApi";

import addNewUsers from "../../assets/svg/add-new-users.svg";
import addWork from "../../assets/svg/registerShow/icon-add-work.svg";
import IconDelete from "../../assets/svg/icon-delete-show-account.svg";
import IconEdit from "../../assets/svg/pen-icon-account.svg";
import IconKey from "../../assets/svg/icon-key-account.svg";
import IconMenu from "../../assets/svg/icon-menu-account.svg";
import LogoShareholder from "../../assets/svg/logo-shareholder.svg";
import UserBackground from "../../assets/svg/users-card-background.svg";

import "../../assets/styles/persons/showUser.scss";

export default function Users({showTitle = true}) {
    const dispatch = useDispatch();

    const users = useSelector((state) => state).userReducer.users;
    const toggle = useSelector((state) => state.appReducer.toggle);
    const sendingRequest = useSelector((state) => state.appReducer.sendingRequest);
    const token = useSelector((state) => state).businessReducer.business?.token;

    const [showUserActions, setShowUserActions] = useState(null);

    useEffect(() => {
        dispatch(resetFormState());
        fetchUsers();
    }, []);

    useEffect(() => {
        fetchUsers();
    }, [sendingRequest]);

    useEffect(() => {
        if (!toggle) setShowUserActions(toggle);
    }, [toggle]);

    const fetchUsers = () => {
        dispatch(apiGetUsers(token));
    };
    const toggleShowUserActions = (id) => {
        dispatch(appSetToggle(showUserActions !== id));
        setShowUserActions(showUserActions === id ? null : id);
    };

    return (
        <div className="wrap-users">
            {showTitle && (
                <div className="header-users">
                    <div className="header-right">
                        <div>کاربران</div>
                        <div>مشاهده کاربران سیستم</div>
                    </div>
                    <div className="header-left"/>
                </div>
            )}
            <div className="body-cards row">
                <AddUserCard/>
                {users.map((user, i) => (
                    <UserCard
                        user={user}
                        i={i}
                        key={user.id}
                        showMenu={toggle && user.id === showUserActions}
                        toggleShowUserActions={toggleShowUserActions}
                    />
                ))}
            </div>
        </div>
    );
}

const AddUserCard = () => {
    const navigate = useNavigate();

    return (
        <a
            className="col-lg-6 col-md-6 col-sm-6 col-xs-6 style-body-card"
            href="/users/add"
            onClick={() => navigate("/users/add")}
        >
            <div className="add-shareholder">
                <div className="wrap-add-shareholder">
                    <div className="item-add-shareholder">
                        <div className="wrap-icon-add-shareholder">
                            <img src={addNewUsers} alt="addNewUsers"/>
                        </div>
                        <div className="add-shareholder-new">
                            <img className="add-icon-shareholder" src={addWork} alt="addWork"/>
                            افزودن کاربر جدید
                        </div>
                    </div>
                </div>
            </div>
        </a>
    );
};

const UserCard = ({user, showMenu, toggleShowUserActions, i}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const token = useSelector((state) => state).businessReducer.business.token;
    const secretView = useSelector((state) => state.appReducer.secretView);

    const deleteUser = (id) => {
        dispatch(setConfirm("کاربر", () => dispatch(apiDeleteUser(id, token))));
    };

    return (
        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 style-body-card">
            <div className="card-box">
                <img src={UserBackground} alt="UserCard"/>
                <div className={showMenu ? "active-toggle-menu-account" : "not-active-toggle-menu-account"}>
                    <div
                        href={`/users/${user.id}`}
                        onClick={(e) => {
                            navigate(`/users/${user.id}`);
                            e.preventDefault();
                        }}
                    >
                        <img src={IconEdit} alt="IconEdit"/>
                        ویرایش
                    </div>
                    <div onClick={() => deleteUser(user.id)}>
                        <img src={IconDelete} alt="IconEdit"/>
                        حذف کاربر
                    </div>
                </div>
                {user.img != null ? <img className="logo-original" src={user.img} alt="original-logo"/> : null}
                <div className="header-card">
                    <div className="right-header-card">
                        <div/>
                        <div/>
                        <div className="logo-card">{i + 1}</div>
                    </div>
                    <div className="left-header-card">
                        <img src={IconMenu} alt="IconMenu" onClick={() => toggleShowUserActions(user.id)}/>
                    </div>
                </div>
                <div className="title-card-box">
                    <div className="new-div-title-card-box">
                        <div className="icon-logo-title-card-box">
                            <img src={LogoShareholder} alt="logoShareholder"/>
                        </div>
                        <div>
                            <div>{secretView ? "********" : `${user.firstName} ${user.lastName ?? ""}`}</div>
                            <div
                                className="text-small-card-box">{secretView ? "********" : user.phone ?? user.email}</div>
                        </div>
                    </div>
                </div>
                <p className="text-number-card">
                    <img className="icon-key-users" src={IconKey} alt="IconKey"/>
                    {secretView ? "********" : user.Roles[0]?.fa_title ?? "استاندارد"}
                </p>
                <div className="branch-card">
                    {user.branch != null ? (
                        <>
                            <img src={IconKey} alt="IconKey"/>
                            <div className="name-branch">{secretView ? "********" : user.branch}</div>
                        </>
                    ) : (
                        <></>
                    )}
                </div>
                <div className="line-card"/>
                <div className="footer-card">{/*<span>آخرین ورود {user.submitDate}</span>*/}</div>
            </div>
        </div>
    );
};
